import { render, staticRenderFns } from "./SimplePassModal.vue?vue&type=template&id=85e19d98&"
import script from "./SimplePassModal.vue?vue&type=script&lang=js&"
export * from "./SimplePassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports